import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '../../../axios/axiosInstance';

export const useLikeProfile = () =>
  useMutation(async (id: number): Promise<void> => {
    await axiosInstance.post(`api/v2/profiles/favorite/${id}`);
  });
